module.exports = __webpack_public_path__ + "img/marketing-marketing.afe5b8bf.png";